import { render, staticRenderFns } from "./SavingsChart.vue?vue&type=template&id=2f7be254&scoped=true&"
import script from "./SavingsChart.vue?vue&type=script&lang=js&"
export * from "./SavingsChart.vue?vue&type=script&lang=js&"
import style0 from "./SavingsChart.vue?vue&type=style&index=0&id=2f7be254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7be254",
  null
  
)

export default component.exports